import { render } from "./Configuracion.vue?vue&type=template&id=7f0204fb&scoped=true"
import script from "./Configuracion.vue?vue&type=script&lang=js"
export * from "./Configuracion.vue?vue&type=script&lang=js"

import "./Configuracion.vue?vue&type=style&index=0&id=7f0204fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0204fb"]])

export default __exports__